import { render, staticRenderFns } from "./BasketCounter.vue?vue&type=template&id=5d5c8930&scoped=true&"
import script from "./BasketCounter.vue?vue&type=script&lang=js&"
export * from "./BasketCounter.vue?vue&type=script&lang=js&"
import style0 from "./BasketCounter.vue?vue&type=style&index=0&id=5d5c8930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c8930",
  null
  
)

export default component.exports